import React, { useEffect, useRef } from "react";
import Header from "../../components/common/Header";
import Button from "../../components/ui/Button";
// Import GSAP
import { gsap } from "gsap";

const HeroSection = () => {
  // 1. Create a ref for the top content area
  const contentRef = useRef(null);
  // 2. Create a ref for the bottom image
  const imageRef = useRef(null);

  useEffect(() => {
    // 3. Set up GSAP context
    const context = gsap.context(() => {
      // ----------------------------------------------------
      // A. Top Content (Title, Paragraph, Button) Animation
      // ----------------------------------------------------
      // Target elements: h1, p, and the div containing the Button
      const animatedElements = gsap.utils.toArray(
        contentRef.current.querySelectorAll(".hero-animated-item")
      );

      // Animation: Slide up and fade in (no ScrollTrigger for immediate load)
      gsap.from(animatedElements, {
        y: 50, // Start 50px below final position
        opacity: 0,
        stagger: 0.2, // Stagger the title, paragraph, and button
        duration: 1.2,
        ease: "power3.out",
        delay: 0.3, // Delay slightly after page load
      });

      // ----------------------------------------------------
      // B. Bottom Image Animation (Slide Up)
      // ----------------------------------------------------
      if (imageRef.current) {
        gsap.from(imageRef.current, {
          y: 100, // Start 100px below
          opacity: 0,
          duration: 1.5,
          ease: "power3.out",
          delay: 0.8, // Delay this after the text has started to appear
        });
      }
    }, [contentRef, imageRef]); // Pass refs to the context

    // 4. Cleanup
    return () => context.revert();
  }, []);

  return (
    <section
      className="w-full bg-cover bg-center relative"
      style={{ backgroundImage: "url(/assets/AboutPageImg/heroBG1.png)" }}
    >
      <Header />
      <div className="absolute inset-0"></div>
      <div className="relative w-full">
        <div className="w-full max-w-[1920px] mx-auto">
          <div className="px-4 sm:px-6 xl:px-0 pb-[14px] sm:pb-[21px] xl:pb-[28px] pt-[14px] sm:pb-[21px] xl:pt-[28px]">
            <div className="w-full max-w-[1620px] mx-auto">
              <div className="flex flex-col items-center">
                <div
                  ref={contentRef} // Attach content ref here
                  className="w-full max-w-[1498px] mx-auto"
                >
                  <div className="flex flex-col items-center gap-[10px] sm:gap-[15px] xl:gap-[20px]">
                    {/* H1 - Added hero-animated-item class */}
                    <h1 className="hero-animated-item text-[50px] sm:text-[65px] md:text-[80px] xl:text-[100px] font-bold font-['Parkinsans'] leading-[70px] sm:leading-[91px] md:leading-[112px] xl:leading-[140px] text-left text-secondary-text">
                      About Utpann
                    </h1>

                    {/* P - Added hero-animated-item class */}
                    <p className="hero-animated-item text-[16px] sm:text-[20px] xl:text-[24px] font-light font-['Poppins'] leading-[25px] sm:leading-[32px] xl:leading-[38px] text-center text-primary-text">
                      It is very important to choose the right method of
                      fertilizer application. Produced by Asia's largest bio-gas
                      plant Govardhannathji Energies LLP. Which can be used as a
                      complete alternative to natural cow-dung fertilizer.
                      Public health so there is need of disposing waste in
                      appropriate manner
                    </p>

                    {/* Button - Wrapped button in a div and added hero-animated-item class */}
                    <div className="hero-animated-item">
                      <Button
                        text="Learn More"
                        text_font_size="text-[16px] sm:text-[20px] xl:text-[24px]"
                        text_font_family="Parkinsans"
                        text_font_weight="font-semibold"
                        text_line_height="leading-[23px] sm:leading-[28px] xl:leading-[34px]"
                        text_text_align="center"
                        text_color="#1c233a"
                        border_border="1px solid #1c233a"
                        border_border_radius="rounded-[50px]"
                        layout_width="auto"
                        padding="t=12px,r=32px,b=12px,l=32px"
                        className=" transition-colors duration-300"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="" ref={imageRef}>
          {" "}
          {/* Attach image ref here */}
          <img
            src="/assets/AboutPageImg/heroBG2.png"
            alt="Organic farming products showcase"
            className="w-full h-auto max-w-[1920px]"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
